import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { context } from '../../App';

const ThemeToggle = () => {
    const { isDarkMode, setIsDarkMode } = useContext(context);

    const handleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        localStorage.setItem('dark-mode', !isDarkMode);
    };

    return (
        <button
            type="button"
            role="switch"
            aria-checked={isDarkMode}
            aria-label="Toggle dark mode"
            onClick={handleDarkMode}
            className={`tap-target relative inline-flex h-8 w-16 shrink-0 items-center rounded-full p-1 border-0 transition-colors duration-300 hover:brightness-105 ${
                isDarkMode
                    ? 'bg-gradient-to-r from-indigo-600 to-purple-600'
                    : 'bg-gradient-to-r from-amber-300 to-orange-400'
            }`}
        >
            {/* static background icons */}
            <FontAwesomeIcon
                icon={faSun}
                className={`absolute left-2 text-xs text-white transition-opacity duration-300 ${isDarkMode ? 'opacity-40' : 'opacity-0'}`}
            />
            <FontAwesomeIcon
                icon={faMoon}
                className={`absolute right-2 text-xs text-white transition-opacity duration-300 ${isDarkMode ? 'opacity-0' : 'opacity-40'}`}
            />
            {/* sliding knob */}
            <span
                className={`inline-flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-e1 transform transition-transform duration-300 ${
                    isDarkMode ? 'translate-x-8' : 'translate-x-0'
                }`}
            >
                <FontAwesomeIcon
                    icon={isDarkMode ? faMoon : faSun}
                    className={`text-xs ${isDarkMode ? 'text-indigo-600' : 'text-orange-400'}`}
                />
            </span>
        </button>
    );
};

export default ThemeToggle;
